<template>
	<div class="position-relative single-select">
		<label v-if="text"
			>{{ text }}<span v-show="isMandatory" class="asterik">*</span></label
		>
		<popper
			trigger="clickToOpen"
			:options="{
				preventOverflow: {
					enabled: true,
				},
				eventsEnabled: false,
			}"
		>
			<template slot="reference">
				<b-dropdown
					:disabled="disabled"
					no-caret
					@shown="isDropdownOpen = true"
					@hidden="isDropdownOpen = false"
					:class="{ errorClass: validation, 'disabled-dropdown': disabled }"
				>
					<template #button-content>
						<span :class="{ 'ss-placeholder-txt': !selectedOption.value }" class="ss-selected-text">{{
							selectedOption.text
						}}</span>
						<div
							:class="
								selectedOption.value && nested
									? 'd-flex align-items-center'
									: ''
							"
						>
							<img
								:class="!isDropdownOpen ? 'pl-3' : 'up-arrow-rotate'"
								src="../../assets/common-icons/bluedownarrow.svg"
							/>
							<div v-if="selectedOption.value && nested && !hideEdit">
								<img
									class="mx-3"
									src="../../assets/common-icons/greyLine.svg"
								/>
								<img
									@click="editSandBox()"
									src="../../assets/common-icons/edit.svg"
								/>
							</div>
						</div>
					</template>
					<b-dropdown-item
						class="bg-single-select"
						@click="selectOption(index)"
						:class="selectedOption.value == item.value ? 'selected-bg' : ''"
						v-for="(item, index) in optionsArray"
						:key="index"
					>
						<div class="d-flex w-100 justify-content-between">
							<div class="padding-10">{{ item.text }}</div>
							<div
								class="padding-10"
								v-if="nested && item.childTemplates.length"
								@mouseenter="selectBranch(item.childTemplates)"
							>
								<img
									class="mx-2"
									src="../../assets/common-icons/greyLine.svg"
								/>
								<img src="../../assets/common-icons/blueRightArrow.svg" />
							</div>
						</div>
					</b-dropdown-item>
				</b-dropdown>
				<div
					v-closable="{
						exclude: ['childBranch'],
						handler: 'hideChildBranch',
					}"
					ref="childBranch"
					v-if="hasBranch"
					class="single-select-radio"
					:class="showLeft ? 'show-left' : ''"
				>
					<b-form-group v-slot="{ ariaDescribedby }">
						<b-form-radio-group
							id="btn-radios-3"
							v-model="selected"
							:options="branches"
							@change="selectedBranch"
							:aria-describedby="ariaDescribedby"
							name="radio-btn-stacked"
							buttons
							stacked
						></b-form-radio-group>
					</b-form-group>
				</div>
				<div
					style="position: absolute; top: 35px; right: 30px; z-index: 1000"
					v-if="validation"
					v-b-popover.hover.top.v-danger="{ content: 'Required' }"
					variant="primary"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
			</template>
		</popper>
	</div>
</template>
<script>
import Popper from "vue-popperjs";

export default {
	name: "SingleSelect",
	components: {
		Popper,
	},
	props: {
		validation: {
			type: Boolean,
			default: false,
		},
		optionsArray: {
			type: Array,
			required: true,
		},
		text: {
			type: String,
			default: "",
		},
		isMandatory: {
			type: Boolean,
			default: false,
		},
		nested: {
			type: Boolean,
			default: false,
		},
		value: {
			type: Object,
			default: () => ({ text: "Select", value: null }),
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		hideEdit: {
			type: Boolean,
			default: false,
		},
		showLeft: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			selected: null,
			hasBranch: false,
			selectedOption: {
				text: "Select",
				value: null,
			},
			branches: [],
			isDropdownOpen: false,
		};
	},
	mounted() {
		if (this.value) this.selectedOption = this.value;
	},
	watch: {
		value(newVal) {
			if (newVal) this.selectedOption = newVal;
			else
				this.selectedOption = {
					text: "Select",
					value: null,
				};
		},
	},
	methods: {
		selectBranch(branches) {
			this.branches = branches.map((value) => ({
				text: value.title,
				value: value.questionKey,
				...value,
			}));
			this.hasBranch = true;
		},
		selectOption(index) {
			this.selectedOption = this.optionsArray[index];
			this.$emit("input", this.selectedOption);
			this.hasBranch = false;
			this.selected = null;
		},
		selectedBranch(selectedBranch) {
			this.selectedOption = this.branches.find(
				(branch) => branch.questionKey === selectedBranch
			);
			this.$emit("input", this.selectedOption);
			this.hasBranch = false;
		},
		hideChildBranch() {
			this.hasBranch = false;
		},
		editSandBox() {
			this.$router.push({
				name: "editsandbox",
				params: { id: this.selectedOption.value },
			});
		},
	},
};
</script>
<style>
.errorClass {
	border-radius: 10px;
	border: 1px solid red !important;
}
.padding-10 {
	padding: 10px;
	white-space: normal;
	word-break: break-word;
}
.single-select ul li {
	width: 100% !important;
	position: relative;
}
.single-select .dropdown .btn-secondary {
	border: 1px solid #d0d5dd;
	background: var(--color-white);
	height: 40px;
	width: 100%;
	color: var(--subheading-color);
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-LM);
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	overflow: hidden;
	min-width: 0;
}
.single-select .btn-secondary:not(:disabled):not(.disabled):active,
.single-select .btn-secondary:not(:disabled):not(.disabled).active,
.single-select .show > .btn-secondary.dropdown-toggle,
.single-select .btn-secondary:not(:disabled):not(.disabled):active:focus,
.single-select .btn-secondary:not(:disabled):not(.disabled).active:focus,
.single-select .show > .btn-secondary.dropdown-toggle:focus {
	color: var(--subheading-color);
	border: 1px solid #d0d5dd;
	background-color: var(--color-white);
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.single-select .btn-secondary:focus,
.btn-secondary.focus {
	color: var(--subheading-color);
	background-color: var(--color-white);
	border-color: #d0d5dd;
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.single-select .dropdown-menu {
	position: absolute;
	top: 100%;
	left: 0;
	z-index: 1001;
	display: none;
	float: left;
	width: 100%;
	min-width: 100%;
	padding: 0 0;
	margin: 0.2rem 0 0;
	font-size: var(--size-16);
	list-style: none;
	background-color: rgba(249, 249, 249, 1);
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, 0.15);
	border-radius: 0.25rem;
	filter: drop-shadow(0px 16px 15px rgba(0, 0, 0, 0.4));
	min-height: auto;
	max-height: 163px;
	overflow-y: auto;
}
.single-select .dropdown-item {
	display: block;
	padding: 0.5rem 0.5rem;
	font-weight: var(--weight-R);
	color: #3a3c40;
	background-color: transparent;
	border: none;
	font-family: "Lato", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-LM);
}

.single-select .btn-group {
	width: 100%;
}

.up-arrow-rotate {
	transform: rotate(179deg);
}
.single-select .dropdown-menu.show {
	display: block !important;
}
.single-select .dropdown-item:hover,
.single-select .dropdown-item:focus {
	color: var(--subheading-color);
	text-decoration: none;
	background-color: #e9ecef;
}

.single-select .dropdown-item:active {
	color: var(--subheading-color);
	text-decoration: none;
	background-color: #c8d9e5;
}
.selected-bg {
	background-color: #c8d9e5;
}

.bg-single-select .dropdown-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	position: relative;
	padding: 0;
}

.single-select-radio {
	position: absolute;
	right: -201px;
	top: 72px;
	z-index: 1000;
	min-height: auto;
	max-height: 150px;
	overflow: auto;
	width: 200px;
	border-radius: 0px 0px 4px 4px;
	filter: drop-shadow(0px 8px 15px rgba(0, 0, 0, 0.4));
}

.single-select-radio .btn-secondary {
	color: #3a3c40;
	background-color: #f9f9f9;
	border-color: #f9f9f9;
	text-align: start;
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 13px;
	color: #3a3c40;
	padding: 10px;
}

.single-select-radio .btn-secondary:not(:disabled):not(.disabled):active,
.single-select-radio .btn-secondary:not(:disabled):not(.disabled).active,
.single-select-radio .show > .btn-secondary.dropdown-toggle {
	color: #3a3c40;
	background-color: #c8d9e5;
	border-color: #c8d9e5;
	text-align: start;
}
.ss-placeholder-txt {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #667085;
}
.ss-selected-text {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	flex: 1;
	min-width: 0;
	text-align: left;
}

.show-left {
	left: -200px !important;
}

.disabled-dropdown {
	box-sizing: border-box;
	background: #8c8c8c26;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
}
</style>
